<template>
<div>

  <!-- PAYMENT MODAL -->
  <div class="modal" :class="{active: active}">
    <div class="modal-overlay"></div>
    <div class="modal-container" style="width:64rem;">
      <div class="modal-header">
        <span class="btn btn-clear float-right" aria-label="Close" @click="hide"></span> 
        <div class="modal-title h5 text-center">Payment Details</div>
      </div>
      <div class="modal-body">
        <div class="columns">
          <div class="col-12 text-center cardTypes">
            We accept
            <i class="fa fa-cc-visa" apaymentError-hidden="true"></i>
            <i class="fa fa-cc-mastercard" aria-hidden="true"></i>
            <i class="fa fa-cc-diners-club" aria-hidden="true"></i>
            <i class="fa fa-cc-amex" aria-hidden="true"></i>
          </div>
        </div>

        <div class="columns" style="margin:0.8em 0">
          <div class="col-5">
            <strong>Invoice amount</strong>
          </div>
          <div class="col-7">
            ${{c2d(amount)}}
          </div>
          <div class="col-5">
            <strong>Payment processing fee</strong>
          </div>
          <div class="col-7">
            ${{c2d(stripeFee(amount))}}
          </div>
        </div>

        <div v-if="showform">
          <div class="columns">
            <div class="col-12">
              <div id="card-element" class="form-input card-input"><!-- a Stripe Element will be inserted here. --></div>
            </div>
          </div>

          <div class="columns" style="margin-top:0.8em;margin-bottom:0.8em">
            <div class="col-12 text-center">
              <button id="paybtn" class="btn btn-primary" @click.prevent="submit" :class="{loading: loading}" style="width:100%">Submit Payment</button>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="col-12 text-center">
            <small>Your credit card information is encrypted <i class="fa fa-lock" aria-hidden="true"></i></small>
          </div>
        </div>

        <div class="columns">
          <div class="col-12">
            <span v-if="cardError" class="label label-error">{{cardError}}</span>
            <span v-if="paymentError" class="label label-error">{{paymentError}}</span>
            <span v-if="success" class="label label-success">Thank you for your payment</span>
          </div>
        </div>

      </div>
    </div>
  </div>
<!-- END PAYMENT MODAL -->

</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'paymentModal',
  props: ['invoice', 'active'],
  data () {
    return {
      cardError: '',
      paymentError: '',
      stripeKey: null,
      stripe: null,
      card: null,
      showform: true,
      success: false,
      loading: false
    }
  },
  mounted () {
    axios.get('/api/stripepk').then(res => {
      if (res.status === 200) {
        this.stripeKey = res.data
        this.mountStripe()
      }
    })
  },
  computed: {
    amount () {
      if (!this.invoice) return null
      let inv = this.invoice
      return inv.plan ? inv.initial : inv.total
    }
  },
  methods: {
    mountStripe () {
      const stripe = window.Stripe(this.stripeKey)
      const elements = stripe.elements()
      const options = {
        base: 'form-input',
        hidePostalCode: true
      }
      const card = elements.create('card', options)

      card.mount('#card-element')
      card.addEventListener('change', ({error}) => {
        this.cardError = error ? error.message : ''
      })

      this.stripe = stripe
      this.card = card
    },
    hide () {
      this.$emit('hide')
    },
    c2d (c) {
      return (c / 100).toFixed(2)
    },
    stripeFee (total) {
      // see https://support.stripe.com/questions/passing-the-stripe-fee-on-to-customers
      let fPercent = 0.0175
      let fFixed = 30
      return (total + fFixed) / (1 - fPercent) - total
    },
    submit: async function () {
      if (this.loading || !this.amount) return
      const btn = document.getElementById('paybtn')
      btn.disabled = true
      this.loading = true
      this.success = false

      const {token, error} = await this.stripe.createToken(this.card)

      if (error) {
        this.cardError = error.message
        this.loading = false
        btn.disabled = false
      } else {
        axios.post('/api/invoices/charge', {
          token: token.id,
          user: this.invoice.user,
          invoice: this.invoice._id,
          desc: this.invoice.ref,
          amount: this.amount
        })
        .then(res => {
          this.card.clear()
          this.loading = false
          btn.disabled = false
          if (res.status === 200) {
            this.paymentError = ''
            this.success = true
            this.showform = false
            this.$emit('payment')
          }
        })
        .catch(e => {
          this.paymentError = e.response.data.message
          this.card.clear()
          this.loading = false
          btn.disabled = false
        })
      }
    }
  }
}
</script>

<style scoped>
.cardTypes {
  background: #dceafe;
  padding: 1em 0;
  color: #458efc;
}
.StripeElement--focus {
  border-color: #5764c6;
}
.card-input {
  padding: 0.35rem .4rem;
}
.label.label-success {
  text-align: center;
  margin: 0.6em 0;
  display: block;
  padding: 0.3em;
}
</style>



// WEBPACK FOOTER //
// paymentModal.vue?1ca2faf4